import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GroupService} from '../../../services/group.service';
import {ServiceTools} from '../../../services/serviceTools';
import {MessageService} from '../../../../shared/message.service';
import {Group} from '../../../interfaces/group';

@Component({
  selector: 'qm-groups-selection',
  templateUrl: './groups-selection.html',
  styleUrls: ['./groups-selection.css']
})
export class GroupsSelectionComponent implements OnInit {

  /**
   * The selected ids when the component is initialized.
   */
  private _groupIds: string[];

  /**
   * Original selected group ids.
   * @param ids The selected ids.
   */
  @Input() set groupIds(ids: string[]) {
    this._groupIds = ids;
  }

  /**
   * The event emitter of selected group change.
   */
  @Output() idsChanged: EventEmitter<string[]> = new EventEmitter<string[]>();

  /**
   * The list of simplified groups from the rest.
   */
  groups: { name: string, groupId: number, selected: boolean }[] = [];

  /**
   * The component is initialized.
   * @param groupService The service used to fetch groups.
   */
  constructor(
    private groupService: GroupService,
    private messageService: MessageService,
  ) {
  }

  /**
   * Selects or unselects the given group.
   * @param group
   */
  selectGroup(group: { name: string, selected: boolean }) {
    if (group.selected) {
      this._groupIds.push(group.name);
    } else {
      this._groupIds = this._groupIds.filter((name: string) => name !== group.name);
    }
    this._groupIds = Array.from(new Set<string>(this._groupIds));
    this.idsChanged.emit(this._groupIds);
  }

  /**
   * Fetch the entities from the backend.
   */
  async fetchEntities(): Promise<void> {
    const groups: Group[] = ServiceTools.getEntitiesFromFirstContext(await this.groupService.getEntities(), this.messageService, 'groups');
    // const groups: Group[] = await this.groupService.getEntities();
    groups.forEach(
      (group: Group) => this.groups.push(
        {
          groupId: group.id,
          name: group.name,
          selected: this._groupIds.some((name: string) => name === group.name)
        }));
  }

  /**
   * Inits the component. Groups are fetched from backend.
   */
  async ngOnInit(): Promise<void> {
    await this.fetchEntities();
  }
}
